import { render, staticRenderFns } from "./DEXT5UploadFor.vue?vue&type=template&id=f4bcc7d8&scoped=true"
import script from "./DEXT5UploadFor.vue?vue&type=script&lang=js"
export * from "./DEXT5UploadFor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4bcc7d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4bcc7d8')) {
      api.createRecord('f4bcc7d8', component.options)
    } else {
      api.reload('f4bcc7d8', component.options)
    }
    module.hot.accept("./DEXT5UploadFor.vue?vue&type=template&id=f4bcc7d8&scoped=true", function () {
      api.rerender('f4bcc7d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/DEXT5UploadFor.vue"
export default component.exports